module.exports = __webpack_public_path__ + "img/bg.27249f0f.png";